import { strReplace } from "../../lib/helper-support";

export type TicketStatus = 'pending_review' | 'in_review' | 'closed' | 'open' | 'awaiting_customer_response'; ;

const statusStyles: Record<TicketStatus, string> = {
  'pending_review': 'bg-yellow-100 text-yellow-800',
  'in_review': 'bg-orange-100 text-orange-800',
  'closed': 'bg-green-100 text-green-800',
  'open': 'bg-blue-100 text-blue-800',
  'awaiting_customer_response': 'bg-red-100 text-red-800',
};

const StatusBadge = ({ status }: { status: TicketStatus }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium uppercase ${statusStyles[status]}`}>
    {strReplace(status, '_', ' ')}
  </span>
);

export default StatusBadge;
